import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const RegexSpan = styled.span.withConfig({
  displayName: "DisplayValueRegex__RegexSpan",
  componentId: "y17j35-0"
})(["word-break:break-all;"]);
export default function DisplayValueRegex(props) {
  const {
    value
  } = props;
  return value ? /*#__PURE__*/_jsx(RegexSpan, {
    "data-selenium-test": "RegexSpan",
    children: value
  }) : null;
}